<template>
  <div id="app">
    <Head @active="updateActive" :active="active" @tab="changeT" @pop="showPop" />
    <div class="main-content">
      <Index v-if="active == 'first'" @pop="showPop"></Index>
      <Bus v-else-if="active == 'bus'" @pop="showPop"></Bus>
      <News v-else-if="active == 'news'" @pop="showPop" @change-id="changeId" @active="updateActive"></News>
      <Detail v-else-if="active == 'detail'" @pop="showPop" :newsId="id"></Detail>
      <Price v-else-if="active == 'price'" @pop="showPop"></Price>
      <Us v-else-if="active == 'us'" @pop="showPop"></Us>
    </div>
    <Footer @pop="showPop"></Footer>
    <div @click="showMsg" class="qrBtn">
      <div class="qr-text">咨询客服</div>
      <img src="./assets/icon_jiantou.png" class="qr-icon"/>
    </div>
    <Pop v-if="show" @pop="showPop" :msg="active" :from="from"></Pop>
  </div>
</template>

<script>
import Head from './components/header.vue';
import Footer from './components/footer.vue';
import Index from './view/index/index.vue';
import Bus from './view/bus/index.vue';
import News from './view/news/index.vue';
import Us from './view/us/index.vue';
import Price from './view/price/index.vue';
import Pop from './components/pop_msg.vue';
import Detail from './view/detail/index.vue';

export default {
  name: 'app',
  components: {
    Head,
    Footer,
    Index,
    Bus,
    Us,
    Pop,
	Price,
	News,
	Detail
  },
  data() {
    return {
      active: 'first',
      show: false,
      from: '',
	  id:''
    };
  },
 
  created() {
	  const currentUrl = window.location.href;
	  const url = new URL(currentUrl);
	  const params = url.searchParams;
	  const foo = params.get('active');
	  if(foo){
		  this.active = foo;
	  }
  },
  methods: {
    updateActive(data) {
      this.active = data;
    },
	changeId(data){
		this.id = data;
	},
    changeT(data) {
      this.tab = data;
    },
    showPop(data) {
      if (data === false) {
        // 关闭弹窗
        this.show = false;
      } else {
        // 打开弹窗
        this.show = true;
      }
    },
    showMsg() {
      this.show = true;
      this.from = 'fixed';
    },
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  font-family: Alibaba PuHuiTi 2.0-55 Regular, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: #ffffff;
  min-height: 100vh;
}
.container, .container-fluid, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {
    --bs-gutter-x: 0;
    --bs-gutter-y: 0;
    width: 100%;
    padding-right: calc(var(--bs-gutter-x) * .5);
    padding-left: calc(var(--bs-gutter-x) * .5);
    margin-right: auto;
    margin-left: auto;
	position: relative;
}
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.main-content {
  flex: 1;
  width: 100%;
  margin: 0 auto;
  padding: 0;
  box-sizing: border-box;
  position: relative;
}
.qrBtn {
  position: fixed;
  right: 0;
  bottom: 200px;
  background: #006DF3;
  width: 150px;
  border-radius: 80px 0 0 80px;
  text-align: center;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  transition: all 0.3s ease;
}
.qr-text {
  display: inline-block;
  font-size: 18px;
  font-weight: 700;
  height: 40px;
  line-height: 40px;
  color: #ffffff;
}
.qr-icon {
  width: 26px;
  height: 26px;
  margin-left: 8px;
  transform: translateY(-3px);
}
.bannerBtn{
		margin-top: 46px;
		display: inline-block;
		background: #006DF3;
		box-shadow: 9px 14px 14px 0px #CED1E0;
		border-radius: 80px;
		padding: 4px 22px;
		color:#ffffff;
		transition: transform 0.3s ease;
	}
.bannerBtn:hover{
	cursor: pointer;
	transform: scale(1.1);
}

.qrBtn:hover {
  cursor: pointer;
  transform: translateX(-5px);
}
@media (max-width: 900px) {
  .main-content {
    padding: 0;
    max-width: 100%;
  }
}
@media (max-width: 768px) {
  .main-content {
    padding: 0;
  }
  .qrBtn {
    display: none;
  }
}
@media (max-width: 480px) {
  .main-content {
    padding: 0;
  }
}
.display-flex{
	display: flex;
}
.mt20{
	margin-top: 20px;
}
.ml20{
	margin-left: 20px;
}
.textL{
		text-align: left;
}
.mt30{
	margin-top: 30px;
}
</style>